/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */

import { type ChangeEvent, useState } from 'react';
import { Typography, Grid, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { strings } from 'i18n/Strings';
import { useDispatch } from 'react-redux';
import { setSnackBarFailed, setSnackBarSuccess } from 'store/snackBar';
import { exportPepReport } from 'service/ReportService';

const PepReport = (): JSX.Element => {
  const [startDate, setStartDate] = useState<string | undefined>(undefined);
  const [endDate, setEndDate] = useState<string | undefined>(undefined);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleExportPepReport = async (): Promise<void> => {
    setLoading(true);
    if (!startDate || !endDate) {
      setLoading(false);
      dispatch(
        setSnackBarFailed({
          snackBarMessage: strings.displayText.selectDateRange,
        }),
      );
      return;
    }
    try {
      const url = await exportPepReport(startDate, endDate);
      const link = document.createElement('a');
      link.href = url as string;
      link.download = `PEP_Report_from_${startDate}_to_${endDate}`;
      link.click();
      dispatch(
        setSnackBarSuccess({
          snackBarMessage: strings.displayText.pepReportExportSuccess,
        }),
      );
    } catch (error) {
      console.log('Error in exporting PEP Report');
      dispatch(
        setSnackBarFailed({
          snackBarMessage: strings.displayText.pepReportExportfailed,
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h4" component="h2" sx={{ marginBottom: 2 }}>
          {/* {strings.displayText.dailyReportBuyLabel} */}
          Select PEP update Date Range
        </Typography>
      </Grid>
      <Grid item sx={{ minWidth: 250 }}>
        <TextField
          type="date"
          label="Start Date"
          value={startDate}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setStartDate(e.target.value)
          }
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
        />
      </Grid>
      <Grid item sx={{ minWidth: 250 }}>
        <TextField
          type="date"
          label="End Date"
          value={endDate}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setEndDate(e.target.value)
          }
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
        />
      </Grid>
      <Grid item>
        <LoadingButton
          loading={loading}
          variant="contained"
          onClick={handleExportPepReport}
        >
          {strings.displayText.export}
        </LoadingButton>
      </Grid>
    </Grid>
  );
};

export default PepReport;
